import { useGenericList } from '@app/hooks/useGenericList';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Dialog, IconButton, LinearProgress, TablePagination } from '@mui/material';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { HeaderAddMedia } from './HeaderAddMedia';
import { MediaListItem } from './MediaListItem';

interface DialogAddMediaProps {
  open: boolean;
  selected: GenericObject[];
  selectOnlyOne?: boolean;
  handleClose(): void;
  handleChangeSelected(selected: GenericObject[]): void;
}

export const DialogAddMedia = ({
  handleClose,
  open,
  selected,
  handleChangeSelected,
  selectOnlyOne,
}: DialogAddMediaProps) => {
  const { data, isLoading, total, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, handleChangeFilters } =
    useGenericList('media', { customRowsPerPage: 100, sort: { field: 'date_created', order: 'DESC' } });

  const selectMedia = (mediaObj: GenericObject) => {
    const alreadySelected = isMediaSelected(mediaObj);
    if (alreadySelected) {
      const filtered = selected.filter((item: GenericObject) => item.id !== mediaObj.id);
      handleChangeSelected(filtered);
      return;
    }

    selectOnlyOne ? (selected = [mediaObj]) : selected.unshift(mediaObj);
    handleChangeSelected([...selected]);
  };

  const isMediaSelected = (media: GenericObject) => {
    return !!selected.find((item: GenericObject) => item.id === media.id);
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="lg">
      <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '10px' }}>
        <IconButton onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <HeaderAddMedia handleChangeFilters={handleChangeFilters} title={'Add Media'} />
      {isLoading && (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      )}

      <div
        id="add-media-list"
        style={{ display: 'flex', flexDirection: 'column', padding: 10, maxHeight: '60vh', overflow: 'auto' }}>
        {data &&
          data.map((mediaObj: GenericObject) => (
            <MediaListItem
              key={mediaObj.id as number}
              mediaObj={mediaObj}
              selectMedia={selectMedia}
              isMediaSelected={isMediaSelected}
            />
          ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px' }}>
        <Button onClick={handleClose} variant="contained">
          DONE
        </Button>
        <TablePagination
          component="div"
          count={total ? total : 0}
          page={page ? page : 0}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage ? rowsPerPage : 10}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </Dialog>
  );
};
